import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGps = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A5A5AA"
      fillRule="evenodd"
      d="M4.138 13.034H2.345A.346.346 0 0 1 2 12.69v-1.38c0-.19.155-.344.345-.345h1.793a7.939 7.939 0 0 1 6.828-6.827V2.345c0-.19.154-.344.344-.345h1.38c.19 0 .344.155.345.345v1.793a7.939 7.939 0 0 1 6.827 6.828h1.793c.19 0 .344.154.345.344v1.38c0 .19-.155.344-.345.345h-1.793a7.939 7.939 0 0 1-6.827 6.827v1.793a.347.347 0 0 1-.345.345h-1.38a.346.346 0 0 1-.345-.345v-1.793a7.939 7.939 0 0 1-6.827-6.827ZM17.862 12A5.862 5.862 0 0 0 12 6.138 5.87 5.87 0 0 0 6.138 12a5.862 5.862 0 0 0 11.724 0ZM12 14.759a2.759 2.759 0 1 0 0-5.517 2.759 2.759 0 0 0 0 5.517Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGps;
